import React from 'react';
import { View } from '@react-pdf/renderer';
import { renderAddress, renderFullName } from '../../utils/helper';
import { Column, Label, Row, SectionHeader, SectionTitle, Value } from '../components';

const SPAuditor = ({ data }) => (
  <>
    <View fixed>
      <SectionHeader text='SERVICE PROVIDERS' />
      <SectionTitle text='AUDITOR' />
    </View>
    {data && data.map((item, i) => {
      const address1 = item.address1 ? item.address1 : '';
      const address2 = item.address2 ? item.address2 : '';
      const address3 = item.address3 ? item.address3 : '';
      const city = item.city ? item.city : '';
      const state = item.state ? item.state : '';
      const zip = item.zip ? item.zip : '';
      const country = item.countryName ? item.countryName : item.country ? item.country : '';
      const hasAddress = address1 || address2 || address3 || city || state || zip || item.countryName || item.country;

      return (
        <View break={i > 0} key={`aud-${i}`}>
          <Row>
            <Column size='100'>
              <Label text='NAME OF FIRM' />
              <Value text={item.name} />
            </Column>
          </Row>
          <Row>
            <Column size='100'>
              <Label text='Phone Number' />
              <Value text={item.phone} />
            </Column>
          </Row>
          <Row>
            <Column size='100'>
              <Label text='Email' />
              <Value text={item.email} />
            </Column>
          </Row>
          <Row>
            <Column size='100'>
              <Label text='Website' />
              <Value text={item.website} />
            </Column>
          </Row>
          <Row>
            <Column size='100'>
              <Label text='Address' />
              <Value text={hasAddress ? renderAddress(address1, address2, address3, city, state, zip, country) : null} />
            </Column>
          </Row>
          <SectionTitle text='PRIMARY CONTACT' />
          <Row>
            <Column size='100'>
              <Label text='Name' />
              <Value text={renderFullName(item.primaryFirstName, item.primaryMiddleName, item.primaryLastName)} />
            </Column>
          </Row>
          <Row>
            <Column size='100'>
              <Label text='Title' />
              <Value text={item.primaryContactTitle} />
            </Column>
          </Row>
          <Row>
            <Column size='100'>
              <Label text='Phone Number' />
              <Value text={item.primaryContactPhone} />
            </Column>
          </Row>
          <Row>
            <Column size='100'>
              <Label text='Email' />
              <Value text={item.primaryContactEmail} />
            </Column>
          </Row>
        </View>
      );
    })}
    {(!data || data.length === 0) && <Value text={null} />}
  </>
);

export default SPAuditor;
